import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  getUserAllAssetLogs,
  exportUserAssetLogs,
} from "../../services/AssetService";
import Pagination from "../Constant/Pagination";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { FaDownload } from "react-icons/fa";

const UserAssetLogsTab = ({ userId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [error, setError] = useState("");
  const [total, setTotal] = useState(0);

  const [param, setParam] = useState({
    query: "",
    page: 1,
    page_size: 10,
  });

  const loadAssetLogs = async () => {
    setLoading(true);
    try {
      const response = await getUserAllAssetLogs(userId, {
        search: param.query,
        page: param.page,
        page_size: param.page_size,
      });

      const results = response.data?.results.results || [];  // <-- FIXED here
      setData(results);
      setTotal(response.data?.count || 0);
      setError("");
    } catch (err) {
      console.error("Failed to load asset logs", err);
      setError("Failed to load asset logs. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAssetLogs();
  }, [param, userId]);

  const handleExport = async () => {
    setExportLoading(true);
    try {
      const response = await exportUserAssetLogs(userId, param.query);  // <-- Pass search term
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const contentDisposition = response.headers["content-disposition"];
      let filename = "asset-logs.xlsx";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="(.+)"/);
        if (match?.[1]) {
          filename = match[1];
        }
      }

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success("Export started successfully");
    } catch (err) {
      console.error("Export failed:", err);
      toast.error("Export failed. Please try again.");
    } finally {
      setExportLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };

  const handleSearchChange = (value) => {
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,  // Reset to first page on search
    }));
  };

  return (
    <div className="card">
      <div className="px-4 py-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div>
          <h5 className="mb-0">Asset Logs for User</h5>
        </div>

        <div className="d-flex flex-wrap align-items-center gap-2">
          <DebounceSmallSearchInput
            handleSearchChange={handleSearchChange}
            placeholder="Search logs..."
          />
          <button
            className="btn btn-success d-flex align-items-center gap-1 align-self-center"
            style={{ padding: "0.4rem 0.6rem" }}
            onClick={handleExport}
            disabled={exportLoading}
          >
            {exportLoading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <FaDownload />
            )}
            Export
          </button>
        </div>
      </div>

      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" />
        </div>
      ) : error ? (
        <div className="text-center my-4 text-danger">{error}</div>
      ) : data.length > 0 ? (
        <>
          <div className="table-responsive">
            <table className="table fs-6 mb-0 align-middle">
              <thead className="table-light custom-thead">
                <tr>
                  <th>#</th>
                  <th>Asset Name</th>
                  <th>Asset Number</th>
                  <th>Category</th>
                  <th>Subcategory</th>
                  <th>Log Type</th>
                  <th>Performed By</th>
                  <th>Remarks</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {data.map((log, index) => (
                  <tr key={log.id}>
                    <td>{(param.page - 1) * param.page_size + index + 1}</td>
                    <td>{log.asset_name}</td>
                    <td>{log.asset_number}</td>
                    <td>{log.category}</td>
                    <td>{log.subcategory}</td>
                    <td>{log.log_type}</td>
                    <td>{log.performed_by}</td>
                    <td>{log.remarks}</td>
                    <td>{log.created_at}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="p-4">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePageChange}
            />
          </div>
        </>
      ) : (
        <div className="text-center my-4">
          No asset logs found for this user.
        </div>
      )}
    </div>
  );
};

export default UserAssetLogsTab;
